import { useState } from "react";
import SubmenuZone from "../Misc/SubmenuZone";
import Image from "next/image";

export const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <div className="navbar px-4 py-5 mx-auto sm:max-w-xl md:max-w-full lg:max-w-full md:px-24 lg:px-8 shadow">
            <div className="relative flex items-center justify-between">
                {/* eslint-disable @next/next/no-html-link-for-pages */}
                <a
                    href="/"
                    aria-label="Scoala de Soferi Buzz Bucuresti"
                    title="Scoala de Soferi Buzz Bucuresti"
                    className="inline-flex items-center"
                >
                    <Image
                        src="/Asset-6.png"
                        className="w-36"
                        alt="Logo Scoala de Soferi Buzz Bucuresti"
                        width={100}
                        height={100}
                    />
                </a>
                <ul className="flex items-center hidden space-x-8 lg:flex">
                    <li>
                        <a
                            href="/"
                            aria-label="Acasă"
                            title="Acasă"
                            className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
                        >
                            Acasă
                        </a>
                    </li>
                    <li>
                        <a
                            href="/preturi-scoala-de-soferi"
                            aria-label="Prețuri Școala de Șoferi"
                            title="Prețuri Școala de Șoferi"
                            className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
                        >
                            Prețuri
                        </a>
                    </li>
                    <li>
                        <a
                            href="/inscriere-scoala-de-soferi"
                            aria-label="Inscriere scoala de soferi"
                            title="Inscriere scoala de soferi"
                            className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
                        >
                            Înscriere
                        </a>
                    </li>
                    <li>
                        <a
                            href="/scoala-de-soferi-categoria-b"
                            aria-label="Școala de Șoferi Categoria B București"
                            title="Școala de Șoferi Categoria B București"
                            className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
                        >
                            Categoria B
                        </a>
                    </li>
                    <li>
                        <a
                            href="/scoala-de-soferi-cutie-automata"
                            className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
                            aria-label="Școala de Șoferi Cutie Automată București"
                            title="Școala de Șoferi Cutie Automată București"
                        >
                            Cutie AUTOMATĂ
                        </a>
                    </li>
                    <SubmenuZone />
                    <li>
                        <a
                            href="/contact"
                            className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
                            aria-label="Școala de Șoferi Cutie Automată București"
                            title="Școala de Șoferi Cutie Automată București"
                        >
                            Contact
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://api.whatsapp.com/send?phone=40766937478&text=BUZZ!%20Vreau%20permis!"
                            className="inline-flex items-center justify-center h-12 px-6 font-medium tracking-wide text-white transition duration-200 rounded shadow-md bg-deep-purple-accent-400 hover:bg-deep-purple-accent-700 focus:shadow-outline focus:outline-none"
                            aria-label="Contactează-ne Rapid"
                            title="Contactează-ne Rapid"
                            target="_blank"
                        >
                            WhatsApp
                        </a>
                    </li>
                </ul>
                <div className="lg:hidden">
                    <button
                        aria-label="Open Menu"
                        title="Open Menu"
                        className="p-2 -mr-1 transition duration-200 rounded focus:outline-none focus:shadow-outline hover:bg-deep-purple-50 focus:bg-deep-purple-50"
                        onClick={() => setIsMenuOpen(true)}
                    >
                        <svg className="w-5 text-gray-600" viewBox="0 0 24 24">
                            <path
                                fill="currentColor"
                                d="M23,13H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,13,23,13z"
                            />
                            <path
                                fill="currentColor"
                                d="M23,6H1C0.4,6,0,5.6,0,5s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,6,23,6z"
                            />
                            <path
                                fill="currentColor"
                                d="M23,20H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,20,23,20z"
                            />
                        </svg>
                    </button>
                    {isMenuOpen && (
                        <div className="absolute top-0 left-0 w-full">
                            <div className="p-5 bg-white border rounded shadow-sm">
                                <div className="flex items-center justify-between mb-4">
                                    <div>
                                        <a
                                            href="/"
                                            aria-label="Scoala de Soferi Buzz Bucuresti"
                                            title="Scoala de Soferi Buzz Bucuresti"
                                            className="inline-flex items-center"
                                        >
                                            <Image
                                                src="/Asset-6.png"
                                                className="w-36"
                                                alt="Logo Scoala de Soferi Buzz Bucuresti"
                                                width={100}
                                                height={100}
                                            />
                                        </a>
                                    </div>
                                    <div>
                                        <button
                                            aria-label="Close Menu"
                                            title="Close Menu"
                                            className="p-2 -mt-2 -mr-2 transition duration-200 rounded hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline"
                                            onClick={() => setIsMenuOpen(false)}
                                        >
                                            <svg
                                                className="w-5 text-gray-600"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    fill="currentColor"
                                                    d="M19.7,4.3c-0.4-0.4-1-0.4-1.4,0L12,10.6L5.7,4.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l6.3,6.3l-6.3,6.3 c-0.4,0.4-0.4,1,0,1.4C4.5,19.9,4.7,20,5,20s0.5-0.1,0.7-0.3l6.3-6.3l6.3,6.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L13.4,12l6.3-6.3C20.1,5.3,20.1,4.7,19.7,4.3z"
                                                />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                <nav>
                                    <ul className="space-y-4">
                                        <li>
                                            <a
                                                href="/"
                                                aria-label="Acasă"
                                                title="Acasă"
                                                className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
                                            >
                                                Acasă
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="/preturi-scoala-de-soferi"
                                                aria-label="Prețuri Școala de Șoferi"
                                                title="Prețuri Școala de Șoferi"
                                                className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
                                            >
                                                Prețuri
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="/inscriere-scoala-de-soferi"
                                                aria-label="Inscriere scoala de soferi"
                                                title="Inscriere scoala de soferi"
                                                className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
                                            >
                                                Înscriere
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="/scoala-de-soferi-categoria-b"
                                                aria-label="Școala de Șoferi Categoria B București"
                                                title="Școala de Șoferi Categoria B București"
                                                className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
                                            >
                                                Categoria B
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="/scoala-de-soferi-cutie-automata"
                                                className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
                                                aria-label="Școala de Șoferi Cutie Automată București"
                                                title="Școala de Șoferi Cutie Automată București"
                                            >
                                                Cutie AUTOMATĂ
                                            </a>
                                        </li>
                                        <SubmenuZone />
                                        <li>
                                            <a
                                                href="/contact"
                                                className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
                                                aria-label="Școala de Șoferi Cutie Automată București"
                                                title="Școala de Șoferi Cutie Automată București"
                                            >
                                                Contact
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="https://api.whatsapp.com/send?phone=40766937478&text=BUZZ!%20Vreau%20permis!"
                                                className="inline-flex items-center justify-center h-12 px-6 font-medium tracking-wide text-white transition duration-200 rounded shadow-md bg-deep-purple-accent-400 hover:bg-deep-purple-accent-700 focus:shadow-outline focus:outline-none"
                                                aria-label="Contactează-ne Rapid"
                                                title="Contactează-ne Rapid"
                                                target="_blank"
                                            >
                                                WhatsApp
                                            </a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
